import React, { Component } from 'react';
import { Header, Segment, Grid, Form, Checkbox, Dropdown } from 'semantic-ui-react';

import { SearchInputBox, Authority } from 'components/Commons';

import storage from 'helpers/storage';
import cm from 'helpers/commons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as cmAction from 'actions/commons';
import StaffList from './StaffList';

const propTypes = {};

const defaultProps = {};

class RightArea extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { param, tabType, staffCheckedData, userCnt, isLoadingBar } = this.props.data;
    const {
      param: nparam,
      tabType: ntabType,
      staffCheckedData: nstaffCheckedData,
      userCnt: nuserCnt,
      isLoadingBar: nisLoadingBar
    } = nextProps.data;
    const changeParams = param !== nparam; // true면 render
    const changeTabType = tabType !== ntabType; // true면 render
    const changeCheckedData = staffCheckedData !== nstaffCheckedData; // true면 render;
    const changeUserCnt = userCnt !== nuserCnt; // true면 render;
    const changeLoadingBar = isLoadingBar !== nisLoadingBar;
    return changeParams || changeTabType || changeCheckedData || changeUserCnt || changeLoadingBar;
  }

  handleStatusChange = async (e, data) => {
    const { cmAPI, fn } = this.props;
    await cmAPI.statusChange({
      type: 'status',
      name: 'value',
      value: data.value
    });
    if (fn.handleSubmit && typeof fn.handleSubmit === 'function') {
      fn.handleSubmit();
    }
  };

  render() {
    const { fn, data, status } = this.props;
    const {
      param: { dormantTargetFilter }
    } = data;
    const comid = ((storage.get('company') || {}).info || {}).id;
    let navi = '전체';
    const options = [
      { value: null, text: '권한 전체' },
      { value: 'USER', text: '일반사용자' },
      { value: 'COM_ADMIN', text: '회사관리자' }
    ];
    if (comid === 'B068366F-5EB8-1C7E-E79C-D438C8E32F9D') {
      options.push({ value: 'SUPER', text: '전체 관리자' });
    }
    if (data.param.orgCode) {
      navi = cm.divisionNavi(data.param.orgCode);
    }
    const statusFilterOptions = [
      { value: null, text: '사용자 상태 전체' },
      { value: 'ACTIVE', text: '활성' },
      { value: 'INACTIVE', text: '일시정지' }
    ];

    return (
      <div style={{ marginRight: 360, height: '100%' }}>
        <Header className="staff-header" attached="top" block>
          {data.tabType === 'division' ? navi : '식대그룹'}
        </Header>
        <Segment attached style={{ height: '100%' }}>
          <Grid className="search-box">
            <Grid.Column floated="left" width={2} style={{ marginRight: 0 }}>
              <span>
                {data.staffCheckedData.length}명 / {data.userCnt}명
              </span>
            </Grid.Column>
            <Grid.Column floated="right" width={14} className="">
              <Form style={{ float: 'right' }}>
                <Form.Group>
                  <Dropdown
                    selection
                    className="authority"
                    placeholder="사용자 상태 전체"
                    value={status ? status.value : null}
                    options={statusFilterOptions}
                    onChange={this.handleStatusChange}
                  />
                  <Authority options={options} fnOnChange={fn.handleSubmit} />
                  <SearchInputBox
                    handleSubmit={fn.handleSubmit}
                    handleEntSubmit={fn.handleEntSubmit}
                    styles={{ width: 250 }}
                    placeHolder="id, 이름, 이메일, 휴대전화번호"
                  />
                </Form.Group>
              </Form>
            </Grid.Column>
          </Grid>
          <StaffList
            params={data.param}
            staffCheckedData={data.staffCheckedData}
            // isLoadingBar={data.isLoadingBar}
            staffSel={fn.staffSel}
            staffChecked={fn.staffChecked}
            isLoadingBarChange={fn.isLoadingBarChange}
          />
        </Segment>
      </div>
    );
  }
}

RightArea.propTypes = propTypes;
RightArea.defaultProps = defaultProps;

export default connect(
  (state) => ({
    status: state.commons.status
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        statusChange: cmAction.ReduxDataSet
      },
      dispatch
    )
  })
)(RightArea);
